import { CardHolderServiceInterface } from "interfaces/card-holder-service.ts"
import { BaseBusinessService } from "services/mms/external-api/business/base-business-service"

export class BusinessCardHolderService
    extends BaseBusinessService
    implements CardHolderServiceInterface
{
    useGetListCardHolders = () => {
        return this.get({ endpoint: "" })
    }

    useGetAllActiveCardHolders() {
        return this.get({ endpoint: "" })
    }

    useGetDriver(driver_id: string) {
        return this.get({ endpoint: `/${driver_id}` })
    }

    useAddCardHolder = () => {
        return this.post({ endpoint: "" })
    }

    useRemoveDriver(driver_id: string) {
        return this.delete({ endpoint: `/${driver_id}` })
    }

    useActivateCardHolder = (driver_id: string) => {
        const body = { active: true }
        return this.put({
            endpoint: `/${driver_id}`,
            options: { body },
        })
    }
    useDeactivateCardHolder = (driver_id: string) => {
        const body = { active: false }
        return this.put({
            endpoint: `/${driver_id}`,
            options: { body },
        })
    }
    useUpdateCardHolder = (driver_id: string) => {
        return this.put({ endpoint: `/${driver_id}` })
    }

    usePostAutochargeToVehicle = () => {
        return this.post({
            endpoint: "/autocharge",
            options: { returnFullResponse: true },
        })
    }
}
